import { Fragment, h } from '@stencil/core';
import isEmpty from 'lodash/isEmpty';
import times from 'lodash/times';
import debounce from 'lodash/debounce';
import { DEBOUNCED_HANDLER_DELAY, EQdsButtonSize, EQdsButtonImportance, BUTTON_TYPES, QdsImportance, ICONS_BY_TYPE, ConfiguratorHandler, getSlottedContent } from '@pes-ui/utils';
import cn from 'classnames';
import { isAppRoutingEnabled } from '../../pes-router/utils';
import { Container } from './Container';
import { isMobile } from '../../../globals/utils';
import { StockQuantityInfo } from './StockQuantityInfo';
import { getCtaInfoMapping } from '../../../globals/utils/helpers';
import { CtaList } from '../../reusable/cta-list';
import { QUANTITY_SELECTOR } from '../../product-description-page/constants';
const SKELETON_HEIGHT = '40px';
export class CtaAreaView {
  constructor() {
    var _a, _b, _c;
    this.unifiedCheckoutFlag = (_a = ConfiguratorHandler.getSingleConfig('FeatureFlags')) === null || _a === void 0 ? void 0 : _a.unifiedCheckout;
    this.isUnifiedCheckoutEnabled = ConfiguratorHandler.isFeatureFlagEnabled(this.unifiedCheckoutFlag || {});
    this.isBatchAddToCartEnabled = (_c = (_b = this.unifiedCheckoutFlag) === null || _b === void 0 ? void 0 : _b.batchAddToCart) !== null && _c !== void 0 ? _c : false;
    this.debouncedHandleResize = debounce(() => {
      this.isMobile = isMobile();
    }, DEBOUNCED_HANDLER_DELAY);
    this.hasSlottedDiscountedPrice = false;
    this.renderSkeletonRow = (index) => {
      return (h("se-skeleton", { key: index, class: "cta-area__skeleton", width: "100%", height: SKELETON_HEIGHT }));
    };
    this.handleAddToCartClick = (event) => {
      const quantity = event.detail;
      if (!quantity)
        return;
      this.ucoAddToCartDidSubmit.emit(quantity);
    };
    this.productId = undefined;
    this.priceHTML = undefined;
    this.secondaryPrice = undefined;
    this.tooltipHTML = undefined;
    this.previousPriceHTML = undefined;
    this.inStockLabel = undefined;
    this.vatLabel = undefined;
    this.resellerLabel = undefined;
    this.buttons = undefined;
    this.showCompare = undefined;
    this.showFavorites = undefined;
    this.showAddedToCartLabel = false;
    this.showSkeleton = false;
    this.isInFavorites = false;
    this.materialPriceGroup = undefined;
    this.removeFromMyProductsLabel = undefined;
    this.addToMyProductsLabel = undefined;
    this.priceFromLabel = undefined;
    this.addedToCartLabel = undefined;
    this.compareLabel = undefined;
    this.selectorConfig = undefined;
    this.showProductSelectorStatus = undefined;
    this.circularEconomyInfo = undefined;
    this.prioritizeBuyNowButton = undefined;
    this.localeCode = undefined;
    this.countryCode = undefined;
    this.shoppableRedirectionData = undefined;
    this.productCR = undefined;
    this.shopSeLink = undefined;
    this.showShopSeLoader = undefined;
    this.stockQuantityLabel = undefined;
    this.isMobile = isMobile();
    this.isPBS = false;
    this.ctaInfo = undefined;
    this.showCtas = undefined;
    this.handleCtaClick = undefined;
    this.productSelectorInfo = undefined;
    this.itemCtas = undefined;
    this.ctaInfoMapping = {};
  }
  windowSizeDidChange() {
    this.debouncedHandleResize();
  }
  componentWillLoad() {
    const slot = this.el.querySelector('slot[name=discounted-price]');
    this.hasSlottedDiscountedPrice = !!getSlottedContent(slot);
    if (!this.showCtas)
      return;
    const productCtas = Object.keys(this.ctaInfo);
    this.ctaInfoMapping = getCtaInfoMapping(productCtas, this.ctaInfo);
    this.itemCtas = productCtas === null || productCtas === void 0 ? void 0 : productCtas.map((item) => {
      var _a, _b, _c, _d;
      if (item !== BUTTON_TYPES.ADD_TO_CART || !this.isBatchAddToCartEnabled)
        return item;
      return {
        cta: item,
        minValue: QUANTITY_SELECTOR.MIN_VALUE,
        maxValue: QUANTITY_SELECTOR.MAX_VALUE,
        maxLength: QUANTITY_SELECTOR.MAX_LENGTH,
        importance: this.ctaInfoMapping[item].importance,
        size: this.ctaInfoMapping[item].size,
        icon: (_a = ICONS_BY_TYPE[item]) !== null && _a !== void 0 ? _a : null,
        label: (_d = (_c = (_b = this.ctaInfo) === null || _b === void 0 ? void 0 : _b[item]) === null || _c === void 0 ? void 0 : _c.label) !== null && _d !== void 0 ? _d : null,
        handleCTAClick: this.handleAddToCartClick,
      };
    });
  }
  renderPriceSection() {
    return ((this.priceHTML || this.secondaryPrice) && (h("div", { class: "cta-area__row cta-area__price-container" }, h("pes-cta-price", { materialPriceGroup: this.materialPriceGroup, priceFromLabel: this.priceFromLabel, priceHTML: this.priceHTML, secondaryPrice: this.secondaryPrice, tooltipHTML: this.tooltipHTML, previousPriceHTML: this.previousPriceHTML, inStockLabel: this.inStockLabel, vatLabel: this.vatLabel, resellerLabel: this.resellerLabel }))));
  }
  renderProductSelectorRow(importance, props) {
    if (!this.selectorConfig)
      return;
    const selectorButtonProps = props;
    selectorButtonProps.importance = importance;
    return (h("div", { class: "cta-area__row" }, h("pes-cta-product-selector", { selectorConfig: this.selectorConfig, isCtaArea: true, buttonProps: selectorButtonProps, showProductSelectorStatus: this.showProductSelectorStatus })));
  }
  renderButton(importance, props) {
    var _a, _b, _c;
    if (isEmpty(props)) {
      return null;
    }
    if (((_a = this.selectorConfig) === null || _a === void 0 ? void 0 : _a.buttonlabel) === props.label
      && !((_b = this.selectorConfig) === null || _b === void 0 ? void 0 : _b.enableNewWidget)) {
      return this.renderProductSelectorRow(importance, props);
    }
    const { showTags, tagText } = props;
    return (h("div", { class: cn('cta-area__row', { 'cta-area__row--with-tag': showTags }) }, h("pes-cta-button", { class: "cta-area__button", importance: importance, size: EQdsButtonSize.LARGE, icon: props.icon, text: props.label, onDidClick: (event) => props.onClick(event.detail), "data-autotests-id": (_c = props.dataset) === null || _c === void 0 ? void 0 : _c.autotestId }), showTags
      && h("qds-tag", { text: tagText, status: "success", importance: QdsImportance.STANDARD })));
  }
  renderAddedToCartLabel() {
    if (!this.addedToCartLabel) {
      return null;
    }
    return (h("pes-cta-added-to-cart-label", { active: this.showAddedToCartLabel }, this.addedToCartLabel));
  }
  renderSkeleton() {
    return (h("div", { class: "cta-area" }, h("div", { class: "cta-area__container-skeleton" }, times(3, this.renderSkeletonRow))));
  }
  renderQuickActions() {
    if (!this.isMobile) {
      return null;
    }
    const myProductsLabels = this.showFavorites
      && this.addToMyProductsLabel
      && this.removeFromMyProductsLabel;
    if (!this.showCompare && !myProductsLabels) {
      return null;
    }
    return (h("div", { class: "cta-area__quick-actions-container" }, h("pes-quick-actions", { class: "cta-area__quick-actions", addToMyProductsLabel: this.addToMyProductsLabel, removeFromMyProductsLabel: this.removeFromMyProductsLabel, compareLabel: this.compareLabel, productId: this.productId, showCompare: this.showCompare, showFavorites: this.showFavorites, isInFavorites: this.isInFavorites, isCta: true })));
  }
  renderButtons() {
    var _a, _b;
    const primaryBtn = this.renderButton(EQdsButtonImportance.EMPHASIZED, (_a = this.buttons) === null || _a === void 0 ? void 0 : _a.emphasized);
    const [firstSecondaryBtnProps, secondSecondaryBtnProps] = ((_b = this.buttons) === null || _b === void 0 ? void 0 : _b.standard) || [];
    const firstSecondaryBtn = this.renderButton(EQdsButtonImportance.STANDARD, firstSecondaryBtnProps);
    const secondSecondaryBtn = this.renderButton(EQdsButtonImportance.STANDARD, secondSecondaryBtnProps);
    if (!primaryBtn && !firstSecondaryBtn && !secondSecondaryBtn) {
      return null;
    }
    return (h(Fragment, null, primaryBtn, firstSecondaryBtn, secondSecondaryBtn, !isAppRoutingEnabled() && this.renderAddedToCartLabel()));
  }
  renderShopSeLink() {
    if (this.showShopSeLoader) {
      return this.renderSkeletonRow;
    }
    return (h("div", { class: "cta-shoppable" }, h("pes-cta-shoppable", { shoppableRedirectionData: this.shoppableRedirectionData, shopSeLink: this.shopSeLink })));
  }
  render() {
    if (this.showSkeleton) {
      return this.renderSkeleton();
    }
    return (h(Container, { hasSlottedDiscountedPrice: this.hasSlottedDiscountedPrice, circularEconomyInfo: this.circularEconomyInfo, prioritizeBuyNowButton: this.prioritizeBuyNowButton, productId: this.productId, localeCode: this.localeCode, countryCode: this.countryCode, isPBS: this.isPBS }, this.renderPriceSection(), h("slot", { name: "discounted-price" }), this.stockQuantityLabel && h(StockQuantityInfo, { stockQuantityLabel: this.stockQuantityLabel }), (!this.isUnifiedCheckoutEnabled)
      ? this.renderButtons() : h(CtaList, { showCtas: this.showCtas, ctaInfo: this.ctaInfo, itemCtas: this.itemCtas, ctaInfoMapping: this.ctaInfoMapping, handleCtaClick: this.handleCtaClick, productSelectorInfo: this.productSelectorInfo }), this.shoppableRedirectionData && this.renderShopSeLink(), this.circularEconomyInfo && (h("div", { class: "circular-economy-container" }, h("pes-circular-economy", { data: this.circularEconomyInfo, productId: this.productId, countryCode: this.countryCode }))), this.renderQuickActions()));
  }
  static get is() { return "pes-cta-area-view"; }
  static get encapsulation() { return "shadow"; }
  static get originalStyleUrls() {
    return {
      "$": ["cta-area-view.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["cta-area-view.css"]
    };
  }
  static get properties() {
    return {
      "productId": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "product-id",
        "reflect": false
      },
      "priceHTML": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "price-h-t-m-l",
        "reflect": false
      },
      "secondaryPrice": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "secondary-price",
        "reflect": false
      },
      "tooltipHTML": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "tooltip-h-t-m-l",
        "reflect": false
      },
      "previousPriceHTML": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "previous-price-h-t-m-l",
        "reflect": false
      },
      "inStockLabel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "in-stock-label",
        "reflect": false
      },
      "vatLabel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "vat-label",
        "reflect": false
      },
      "resellerLabel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "reseller-label",
        "reflect": false
      },
      "buttons": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "TRenderButtons",
          "resolved": "{ emphasized?: TRenderButtonProps; standard?: TRenderButtonProps[]; }",
          "references": {
            "TRenderButtons": {
              "location": "import",
              "path": "./types"
            }
          }
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        }
      },
      "showCompare": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "show-compare",
        "reflect": false
      },
      "showFavorites": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "show-favorites",
        "reflect": false
      },
      "showAddedToCartLabel": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "show-added-to-cart-label",
        "reflect": false,
        "defaultValue": "false"
      },
      "showSkeleton": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "show-skeleton",
        "reflect": false,
        "defaultValue": "false"
      },
      "isInFavorites": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "is-in-favorites",
        "reflect": false,
        "defaultValue": "false"
      },
      "materialPriceGroup": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "TMaterialPriceGroup",
          "resolved": "{ price: string; label: string; }",
          "references": {
            "TMaterialPriceGroup": {
              "location": "import",
              "path": "./types"
            }
          }
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        }
      },
      "removeFromMyProductsLabel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "remove-from-my-products-label",
        "reflect": false
      },
      "addToMyProductsLabel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "add-to-my-products-label",
        "reflect": false
      },
      "priceFromLabel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "price-from-label",
        "reflect": false
      },
      "addedToCartLabel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "added-to-cart-label",
        "reflect": false
      },
      "compareLabel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "compare-label",
        "reflect": false
      },
      "selectorConfig": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "TScHpcProductSelectorConfig",
          "resolved": "Omit<TScProductSelectorConfig, \"type\"> & Omit<THpcProductSelectorConfig, \"type\"> & { type: \"hpc\" | \"cr\" | \"sc\"; }",
          "references": {
            "TScHpcProductSelectorConfig": {
              "location": "import",
              "path": "@pes-ui/utils"
            }
          }
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        }
      },
      "showProductSelectorStatus": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "TProductSelectorStatus",
          "resolved": "{ loaded: boolean; isExternalState: boolean; state: boolean; }",
          "references": {
            "TProductSelectorStatus": {
              "location": "import",
              "path": "../../../globals/types"
            }
          }
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        }
      },
      "circularEconomyInfo": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "CircularEconomy",
          "resolved": "{ circularCertifiedLogo?: string; message?: string; apiEndPointUrl?: string; toolTipMessage?: string; toolTipLearnMoreLabel?: string; toolTipLearnMoreUrl?: string; apiKey?: string; enableCircularProducts?: boolean; enableCircularProductNewBadge?: boolean; }",
          "references": {
            "CircularEconomy": {
              "location": "import",
              "path": "../../circular-economy/types"
            }
          }
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        }
      },
      "prioritizeBuyNowButton": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "prioritize-buy-now-button",
        "reflect": false
      },
      "localeCode": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "locale-code",
        "reflect": false
      },
      "countryCode": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "country-code",
        "reflect": false
      },
      "shoppableRedirectionData": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "TShopableRedirectionCtaData",
          "resolved": "{ shoppableRedirectionLabel: string; shoppableBuyButtonLabel: string; link: { shopableRedirectionHostUrl: string; shoppableRedirectionClickableLabel: string; }; }",
          "references": {
            "TShopableRedirectionCtaData": {
              "location": "import",
              "path": "../../product-description-page/product-main/types"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        }
      },
      "productCR": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "product-c-r",
        "reflect": false
      },
      "shopSeLink": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "shop-se-link",
        "reflect": false
      },
      "showShopSeLoader": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "show-shop-se-loader",
        "reflect": false
      },
      "stockQuantityLabel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "stock-quantity-label",
        "reflect": false
      },
      "isPBS": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Defines whether the component is integrated to PBS."
        },
        "attribute": "is-p-b-s",
        "reflect": false,
        "defaultValue": "false"
      },
      "ctaInfo": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "ProductsApi.TCtaInfo",
          "resolved": "{ [key: string]: { type: string; label?: string; primary?: boolean; url?: string; gaAttributes?: TGaAttributes; }; }",
          "references": {
            "ProductsApi": {
              "location": "import",
              "path": "@pes-ui/utils"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        }
      },
      "showCtas": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "show-ctas",
        "reflect": false
      },
      "handleCtaClick": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "(cta: Values<typeof BUTTON_TYPES>) => void",
          "resolved": "(cta: Values<{ readonly ADD_TO_CART: \"ADD_TO_MY_CART\"; readonly ADD_TO_MYLIST: \"ADD_TO_MY_LIST\"; readonly NOTIFY_ME: \"NOTIFY_ME\"; readonly VIEW_DETAILS: \"VIEW_DETAILS\"; readonly DOWNLOAD_SOFTWARE: \"DOWNLOAD_SOFTWARE\"; readonly VIEW_ONLINE_SOFTWARE: \"VIEW_ONLINE_SOFTWARE\"; readonly SEE_SOFTWARE: \"SEE_SOFTWARE\"; readonly PRODUCT_SELECTOR: \"PRODUCT_SELECTOR\"; }>) => void",
          "references": {
            "Values": {
              "location": "import",
              "path": "@pes-ui/utils"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        }
      },
      "productSelectorInfo": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "ProductSelectorInfo",
          "resolved": "{ selectorConfig: TScHpcProductSelectorConfig; isCtaArea: boolean; buttonProps?: TRenderButtonProps; showProductSelectorStatus: TProductSelectorStatus; addToMyCartLabel?: string; addToMyListLabel?: string; }",
          "references": {
            "ProductSelectorInfo": {
              "location": "import",
              "path": "../../../globals/types"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        }
      }
    };
  }
  static get states() {
    return {
      "isMobile": {},
      "itemCtas": {},
      "ctaInfoMapping": {}
    };
  }
  static get events() {
    return [{
        "method": "notifyButtonDidClick",
        "name": "notifyButtonDidClick",
        "bubbles": true,
        "cancelable": true,
        "composed": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        }
      }, {
        "method": "downloadButtonDidClick",
        "name": "downloadButtonDidClick",
        "bubbles": true,
        "cancelable": true,
        "composed": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        }
      }, {
        "method": "ucoAddToCartDidSubmit",
        "name": "ucoAddToCartDidSubmit",
        "bubbles": true,
        "cancelable": true,
        "composed": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "complexType": {
          "original": "number",
          "resolved": "number",
          "references": {}
        }
      }];
  }
  static get elementRef() { return "el"; }
  static get listeners() {
    return [{
        "name": "resize",
        "method": "windowSizeDidChange",
        "target": "window",
        "capture": false,
        "passive": true
      }];
  }
}
